import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { App } from "./App.tsx";
import { ToastProvider } from "./ui/index.ts";
import "./index.css";

const el = document.getElementById("root");
if (!el) throw new Error("#root missing");

createRoot(el).render(
	<StrictMode>
		<ToastProvider>
			<BrowserRouter>
				<App />
			</BrowserRouter>
		</ToastProvider>
	</StrictMode>,
);
